import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import LiveChatService from '../../../../old-crazy-web-frontend/src/app/utils/live-chat/live.chat.service';

@Injectable()
export class Ng1LiveChatService {
  public liveChatService: LiveChatService;

  constructor(private configService: ConfigService) {
    this.liveChatService = configService.getValue('LiveChat');
  }

  contactSupport() {
    this.liveChatService.contactSupport();
  }
}
